<template>
    <div tabindex="0" ref="imguploader" class="uploader">
        <h4 class="title" v-if="title">{{ $t(title) }}{{ hasPunctuation ? ':' : '' }}</h4>
        <form enctype="multipart/form-data" novalidate>
            <div class="drop-tile" :class="isOver ? ' hover-draganddrop' : ''">
                <input
                    ref="inputFileImage"
                    type="file"
                    multiple
                    :name="uploadFieldName"
                    :disabled="isSaving || !paramsLoaded"
                    :accept="acceptExtension"
                    class="input-file"
                    @change="
                        filesChange($event.target.name, $event.target.files);
                        fileCount = $event.target.files.length;
                    "
                    @click="resetImageUploader"
                />
                <div class="catalogo-box" v-if="isCatalogo || isCatalogoMini">
                    <div class="icon-box" v-if="isCatalogo">
                        <svg class="catalogo-icon">
                            <use
                                :xlink:href="
                                    require('@/assets/img/icons/cloud-upload.svg') + '#layer'
                                "
                            ></use>
                        </svg>
                    </div>
                    <div class="text-box">
                        <p>
                            {{
                                $t('msg-catalogo-tipo-imagem-upload-n', { n: maxFileSizeMb })
                            }}
                        </p>
                        <p v-if="isCatalogo">{{ $t('msg-formato-nome-imagens') }}</p>
                        <p v-if="isCatalogo">{{ $t('msg-formato-nome-imagens-exemplo') }}</p>
                        <p class="bold">
                            {{
                                $t(
                                    'msg-dimensoes-maximas-a-l', 
                                    { a: maxImageHeight, l: maxImageWidth }
                                )
                            }}
                        </p>
                    </div>
                </div>
                <p
                    v-else-if="
                        isInitial &&
                        !logourl &&
                        !isCatalogo &&
                        !isCatalogoMini &&
                        minImageHeight > 0 &&
                        minImageWidth > 0
                    "
                >
                    {{
                        $t(
                            'initial-state-imageuploader-la-lmam', 
                            { 
                                a: maxImageHeight,
                                l: maxImageWidth,
                                am: minImageHeight,
                                lm: minImageWidth
                            }
                        )
                    }}
                </p>
                <p v-else-if="isInitial && !logourl && !isCatalogo && !isCatalogoMini">
                    {{
                        $t(
                            'initial-state-imageuploader-la', 
                            { a: maxImageHeight, l: maxImageWidth }
                        )
                    }}
                </p>
                <p v-else-if="isSaving && !isCatalogo && !isCatalogoMini">
                    {{ $t('uploading') }}
                </p>
                <div
                    class="img-preview"
                    v-else-if="
                        logourl && !isSaving && !hidePreview && !isCatalogo && !isCatalogoMini
                    "
                >
                    <img :src="logourl" alt="" />
                </div>
                <p v-else-if="isFailed && !isCatalogo && !isCatalogoMini">
                    {{ $t('upload-falhou') }}
                </p>
            </div>
        </form>
    </div>
</template>

<script>
import ParametroService from '@/services/vendas/produto/ParametroService';

const STATUS_INITIAL = 0,
    STATUS_SAVING = 1,
    STATUS_SUCCESS = 2,
    STATUS_FAILED = 3;
export default {
    props: {
        extensions: {
            type: Array,
            default: () => ['jpg', 'jpeg', 'png'],
        },
        title: {
            default: 'logo',
        },
        logourl: {
            default: '',
        },
        hidePreview: {
            type: Boolean,
            default: () => false,
        },
        addImageToList: {
            type: Boolean,
            default: () => false,
        },
        isCatalogo: {
            type: Boolean,
            default: () => false,
        },
        isCatalogoMini: {
            type: Boolean,
            default: () => false,
        },
        acceptExtension: {
            type: String,
            default: 'image/*',
        },
        qtdImagesAdd: {
            type: Number,
            default: 0,
        },
        dataImage: {
            type: Object,
            default: () => ({
                largura: '1000',
                altura: '1000',
                size: '2MB',
            }),
        },
        customMaxFileSizeMb: {
            type: Number,
            default: null,
        },
        customMaxImageHeight: {
            type: Number,
            default: null,
        },
        customMaxImageWidth: {
            type: Number,
            default: null,
        },
        customMinImageHeight: {
            type: Number,
            default: null,
        },
        customMinImageWidth: {
            type: Number,
            default: null,
        },
        isStrict: {
            type: Boolean,
            default: () => false,
        },
    },

    data() {
        return {
            parametroService: new ParametroService(this.$http, this.$router),
            fileurl: '',
            uploadError: null,
            currentStatus: null,
            uploadedFiles: [],
            uploadFieldName: 'logos',
            hasPunctuation: true,
            maxFileSize: 2097152, // 2mb
            maxFileSizeMb: 2,
            maxImageHeight: 1000,
            maxImageWidth: 1000,
            minImageHeight: 0,
            minImageWidth: 0,
            paramsLoaded: true,
            isOver: false,
            numOfImagesRemoved: {
                qtdDimensao: 0,
                qtdExtensao: 0,
                qtdSize: 0,
                qtdErasedByLimit: 0,
            },
        };
    },
    created() {
        if (this.isCatalogo || this.isCatalogoMini) {
            this.loadCatalogParameter();
        }

        if (this.customMaxFileSizeMb) {
            this.maxFileSizeMb = this.customMaxFileSizeMb;
        }

        if (this.customMaxImageHeight) {
            this.maxImageHeight = this.customMaxImageHeight;
        }

        if (this.customMaxImageWidth) {
            this.maxImageWidth = this.customMaxImageWidth;
        }

        if (this.customMinImageHeight) {
            this.minImageHeight = this.customMinImageHeight;
        }

        if (this.customMinImageWidth) {
            this.minImageWidth = this.customMinImageWidth;
        }
    },
    computed: {
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED;
        },
    },
    mounted() {
        this.$refs.inputFileImage.addEventListener('dragover', () => {
            this.isOver = true; // add class on drag over
        });
        this.$refs.inputFileImage.addEventListener('dragleave', () => {
            this.isOver = false; // remove class on drag leave
        });

        this.reset();
    },
    methods: {
        reset() {
            // reset form to initial state
            // document.addEventListener('ondragover', (e) => this.dragged('dragstart'));
            // document.addEventListener('ondragenter', (e) => this.dragged('dragstart'));
            // document.addEventListener('ondragleave', (e) => this.dragged('dragstart'));
            // document.addEventListener('ondragend', (e) => this.dragged('dragstart'));

            this.currentStatus = STATUS_INITIAL;
            this.uploadedFiles = [];
            this.uploadError = null;
        },
        dragged(styleClass) {
            this.$refs.imguploader.classList.add(styleClass);
        },
        draggedEnd(styleClass) {
            this.$refs.imguploader.classList.remove(styleClass);
        },
        save(formData) {
            // upload data to the server
            this.currentStatus = STATUS_SAVING;

            this.upload(formData)
                .then((x) => {
                    let list = x.filter(Boolean); // Remove todos os valores undefined, imagens que foram removidas por passar do tamanho máximo aceitavel.
                    if (!this.addImageToList) {
                        this.uploadedFiles = [].concat(list);
                    } else {
                        this.uploadedFiles.push(...list);
                    }

                    if (this.uploadedFiles[0]) {
                        this.currentStatus = STATUS_SUCCESS;
                    } else {
                        if (this.currentStatus == STATUS_FAILED) {
                            if (!this.isCatalogo) {
                                let larguraMax = this.dataImage.largura;
                                let alturaMax = this.dataImage.altura;
                                let message = '';

                                if (this.minImageHeight > 0 && this.minImageWidth > 0) {
                                    message = this.$t(
                                        'msg-imagem-dimensoes-invalida-l-a-lm-am', {
                                            l: larguraMax,
                                            a: alturaMax,
                                            lm: this.minImageWidth,
                                            am: this.minImageHeight
                                        }
                                    );
                                } else {
                                    message = this.$t(
                                        'msg-imagem-dimensoes-invalida-l-a', 
                                        { l: larguraMax, a: alturaMax }
                                    );
                                }

                                this.$root.showMessage('error', message, true, false);
                            }
                        }
                        this.currentStatus = STATUS_FAILED;
                        this.uploadedFiles = [];
                    }

                    this.$emit('filesRemoved', this.numOfImagesRemoved);
                    this.$emit('uploadedFiles', this.uploadedFiles);
                })
                .catch((err) => {
                    this.uploadError = err.response;
                    this.currentStatus = STATUS_FAILED;
                });
        },
        filesChange(fieldName, fileList) {
            // handle file changes
            const formData = new FormData();

            if (!fileList.length) return;
            if (this.qtdImagesAdd == 100) return;

            let limitedFileList = Object.assign(fileList);
            let qtdMissing = 100 - this.qtdImagesAdd;
            if (fileList.length > qtdMissing) {
                limitedFileList = [];
                Array.from(Array(fileList.length).keys()).forEach((x) => {
                    if (x < qtdMissing) {
                        limitedFileList.push(fileList[x]);
                    } else {
                        this.numOfImagesRemoved.qtdErasedByLimit++;
                    }
                });
            }

            // append the files to FormData
            Array.from(Array(limitedFileList.length).keys()).map((x) => {
                let item = limitedFileList[x];
                let extensionValid = this.extensions.includes(item.type.split('/')[1]);
                let sizeValid = item.size < this.maxFileSize;

                if (extensionValid && sizeValid) {
                    formData.append(fieldName, item, item.name);
                } else {
                    if (!extensionValid) {
                        if (!this.isCatalogo) {
                            this.$root.showMessage('error', 'msg-formato-invalido', true);
                        }
                        this.numOfImagesRemoved.qtdExtensao++;
                    }

                    if (!sizeValid) {
                        if (!this.isCatalogo) {
                            let size = this.dataImage.size;
                            let message = this.$t('msg-tamanho-invalido-n', { n: size });
                            this.$root.showMessage('error', message, true, false);
                        }
                        this.numOfImagesRemoved.qtdSize++;
                    }
                }
            });

            // save it
            if ([...formData].length > 0) {
                this.currentStatus = STATUS_FAILED;
            }

            this.save(formData);
        },
        upload(formData) {
            const photos = formData.getAll('logos');
            const promises = photos.map((x) =>
                this.getImage(x).then((img) => {
                    // Adicionada validação de tamanho, só retorna as imagens que não passarem do tamanho maximo.
                    let height = img.target.height;
                    let width = img.target.width;
                    let isInRange = false;

                    if (this.isStrict) {
                        isInRange = height === this.maxImageHeight && width === this.maxImageWidth;
                    } else if (this.minImageHeight > 0 && this.minImageWidth > 0) {
                        isInRange =
                            height <= this.maxImageHeight &&
                            height >= this.minImageHeight &&
                            width <= this.maxImageWidth &&
                            width >= this.minImageWidth;
                    } else {
                        isInRange = height <= this.maxImageHeight && width <= this.maxImageWidth;
                    }

                    if (isInRange) {
                        return {
                            file: x,
                            id: img,
                            originalName: x.name,
                            fileName: x.name,
                            url: img,
                            imgurl: URL.createObjectURL(x),
                        };
                    } else {
                        this.numOfImagesRemoved.qtdDimensao++;
                        this.currentStatus = STATUS_FAILED;
                    }
                })
            );
            return Promise.all(promises);
        },
        getImage(file) {
            return new Promise((resolve, reject) => {
                const fReader = new FileReader();
                const img = document.createElement('img');

                fReader.onload = () => {
                    img.src = fReader.result;
                    img.onload = (im) => {
                        return resolve(im);
                    };
                    img.onerror = (e) => {
                        console.error('Erro ao carregar imagem.', e);
                        this.currentStatus = STATUS_FAILED;
                    };
                };

                fReader.readAsDataURL(file);
            });
        },
        getBase64Image(img) {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);

            return canvas.toDataURL('image/png');
        },
        /**
         * Busca parametros de controle para o catalogo.
         */
        loadCatalogParameter() {
            this.paramsLoaded = false;
            this.parametroService
                .findParametroByNome('CATALOGO_TAMANHO_IMAGEM')
                .then((r) => {
                    let mbVal = r.content;

                    if (mbVal && mbVal.valor) {
                        this.maxFileSizeMb = this.customMaxFileSizeMb
                            ? this.customMaxFileSizeMb
                            : mbVal.valor;
                        // Transforma valor de MB para bytes.
                        this.maxFileSize = this.customMaxFileSizeMb
                            ? this.customMaxFileSizeMb
                            : (mbVal.valor ? mbVal.valor : 2) * Math.pow(1024, 2); // 1MB em Bytes * valor da config;
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa.`, e);
                })
                .finally(() => {
                    this.paramsLoaded = true;
                });

            this.parametroService
                .findParametroByNome('CATALOGO_DIMENSOES_MAXIMA_IMAGEM')
                .then((r) => {
                    let param = r.content;

                    if (param && param.valor) {
                        let dimensoes = param.valor;
                        let dimensions = dimensoes.toLowerCase().split('x');
                        this.maxImageWidth = this.customMaxImageWidth
                            ? this.customMaxImageWidth
                            : Number(dimensions[0]);
                        this.maxImageHeight = this.customMaxImageHeight
                            ? this.customMaxImageHeight
                            : Number(dimensions[1]);
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa.`, e);
                })
                .finally(() => {
                    this.paramsLoaded = true;
                });
        },
        // precisa voltar o valor do input para o @change funcionar novamente.
        resetImageUploader(event) {
            if (this.qtdImagesAdd == 100) {
                event.preventDefault();
                this.$emit('maxImageAdd');
            } else {
                this.$refs.inputFileImage.value = '';
                this.numOfImagesRemoved.qtdDimensao = 0;
                this.numOfImagesRemoved.qtdExtensao = 0;
                this.numOfImagesRemoved.qtdSize = 0;
                this.numOfImagesRemoved.qtdErasedByLimit = 0;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.uploader {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    form {
        max-width: 100%;
        height: calc(100% - 26px);
    }

    .title {
        font-size: 12px;
        color: $darker-gray-color;
        font-weight: 600;
        margin-bottom: 0;
        text-transform: capitalize;
        padding-bottom: 2px;
        padding-top: 0px;
    }

    .drop-tile {
        outline: 2px dashed $table-border; /* the dash box */
        box-shadow: inset 0 0 3px 2px rgba(10, 10, 10, 0.1);
        outline-offset: -10px;
        // background: $darker-bg-color;
        background: $sovis-white;
        color: $semi-title-color;
        padding: 10px 10px;
        height: 100%;
        width: 100%;
        min-height: 150px; /* minimum height */
        min-width: 150px;
        position: relative;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
            background: $primary-color-hover;

            p {
                color: $sovis-white;
            }
        }

        &.hover-draganddrop {
            background: $primary-color-hover !important;

            p {
                color: $sovis-white !important;
            }
        }

        p {
            position: relative;
            text-align: center;
            width: 80%;
            font-size: 12px;
            z-index: 0;
        }

        .img-preview {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                object-fit: contain;
                width: auto !important;
                height: auto !important;
                max-height: 100%;
                max-width: 100%;
            }
        }
    }
    .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        height: 100%;
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        font-size: 4px !important;
        z-index: 10;
    }

    &.dragstart .drop-tile {
        background: $primary-color-hover;
    }

    .catalogo-box {
        max-width: 75%;
        .icon-box {
            display: flex;
            justify-content: center;

            .catalogo-icon {
                width: 400px;
                height: 400px;
                fill: $primary-color;
            }
        }
        .text-box p {
            width: 100%;
            font-size: 16px;
        }
        .text-box .bold {
            font-weight: 900;
        }
    }
}
</style>
